import script from "./CategoryBreakdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryBreakdown.vue?vue&type=script&setup=true&lang=js"

import "./CategoryBreakdown.vue?vue&type=style&index=0&id=43ff853e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ff853e"]])

export default __exports__